/* eslint no-cond-assign: "off", no-useless-escape: "off" */
/* global Provider */
import React, { Component } from 'react';
import DisclosuresPage from './DisclosuresPage';
import EndnotesPage from './EndnotesPage';
import RankGraphPage from './RankGraphPage';
import SummaryPage from './SummaryPage';
import TitlePage from './TitlePage';
import TocPage from './TocPage';
import html2pdf from 'html2pdf.js';
import $ from 'jquery';
import MethodologyPages from './MethodologyPages';
import RiskProfilePage from './RiskProfilePage';
import FullSummaryPage from './FullSummaryPage';

class Report extends Component {
    constructor(props){
        super(props);

        this.pageInc = 0;
        this.downloadReport = this.downloadReport.bind(this);
        this.cleanupHtmlBeforeRender = this.cleanupHtmlBeforeRender.bind(this);

        this.state = {
            showingPageNumbers: true
        }
    }

    handleKeyDown(event){
        if (event.key === "Escape"){
            this.props.hideReport();
        }
    }

    componentDidMount() {
        window.addEventListener('keydown', this.handleKeyDown.bind(this));
    }

    componentWillUnmount() {
        window.removeEventListener('keydown', this.handleKeyDown.bind(this));
    }

    componentDidUpdate(){
        this.pageInc = 0;
    }

    getPage(increment){
        return this.pageInc = this.pageInc + (increment || 1);
    }

    downloadReport(){   
        let self = this;
        let $container = $('#ReportOutput');
        $container.removeClass('report-landscape');
        let isIE = !!window.MSInputMethodContext && !!document.documentMode;

        if (isIE){
            //console.log('Altering SVG for IE11');
            var svgTags = $container[0].querySelectorAll('svg');
            for (var i = 0; i < svgTags.length; i++) {
                var svgTag = svgTags[i];
                var c = document.createElement('canvas');
                if (typeof(svgTag.clientWidth) !== 'undefined' && typeof(svgTag.clientHeight) !== 'undefined') {
                    c.width = svgTag.clientWidth;
                    c.height = svgTag.clientHeight;
                } else {
                var rect = svgTag.getBoundingClientRect();
                    c.width = rect.width;
                    c.height = rect.height;
                }
                svgTag.parentNode.insertBefore(c, svgTag);
                svgTag.parentNode.removeChild(svgTag);
                //var div = document.createElement('div');
                var xml = (new XMLSerializer()).serializeToString(svgTag);
                var start = xml.indexOf("<svg");
                var end = xml.lastIndexOf("/svg>");
                xml = xml.substring(start,end+5);
                xml = xml.replace(/xmlns=\"http:\/\/www.w3.org\/2000\/svg\"/g, '');
                xml = xml.replace(/xmlns:NS1=\"\"/g, '');
                xml = xml.replace(/NS1:xmlns:xlink=\"http:\/\/www.w3.org\/1999\/xlink\"/g, 'xmlns:xlink=\"http:\/\/www.w3.org\/1999\/xlink\"');
                xml = xml.replace(/xmlns:xlink=\"http:\/\/www.w3.org\/1999\/xlink\" xlink:href/g, 'xlink:href');
                xml = xml.replace(/Created with Raphaël 2\.1\.2<\/desc>/g,"");
                xml = xml.replace(/ undefined<\/span>/g,"");
                xml = xml.replace(/undefined<\/span>/g,"");
                window.canvg(c, xml);
            }   
        }    
        
        window.setTimeout(() => {
            var isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
            let isIE = !!window.MSInputMethodContext && !!document.documentMode;
            let scale = (isFirefox || isIE) ? 1.0 : 1.0;
            var img = { type: 'jpeg', quality: 1.0 };
            var orientation = 'portrait';
            if (!this.props.portrait) {
                orientation = 'landscape';
            }
            var opt = {
                margin:       0,
                enableLinks:  true,
                filename:     this.props.reportIncludesMethodology?'target-date-blueprint-methodology.pdf':'target-date-blueprint.pdf',
                image:        img,
                html2canvas:  { scale: scale, onclone: self.cleanupHtmlBeforeRender },
                jsPDF:        { unit: 'in', format: 'letter', orientation: orientation }
            };
            html2pdf().from($container[0]).set(opt).save().then(() => {
                if (!this.props.portrait) {
                    $container.addClass('report-landscape');
                }
            });       
        }, 100);

        Provider.submitAciData('report downloaded', this.props.reportIncludesMethodology);
    }   
    
    cleanupHtmlBeforeRender(doc){
        let $doc = $(doc);
        return $doc[0]; 
    }

    cleanupHtmlBeforeRender1(doc){
        let $doc = $(doc);
        $doc.find('.recharts-label, .recharts-cartesian-axis-tick-value').css({ 
            'font-family': 'sans-serif',
            'font-size': '10px'
        });

        $doc.find('.recharts-text .recharts-label text, .recharts-text .recharts-label tspan').css({
            'font-size': '10px',
            'font-weight': '400',
            'fill': '#6c757d',
            'color': '#6c757d'
        });

        $doc.find('.recharts-reference-line .recharts-label text, .recharts-reference-line .recharts-label tspan').css({
            'fill': '#2b5592',
            'color': '#2b5592',
            'font-size': '10px',
            'font-weight': '400'
        });

        $doc.find('.col-8.bg-gray.replaceBeforeRender').removeClass('col-8').addClass('col-6');
        $doc.find('.col-8.replaceBeforeRender').removeClass('col-8').addClass('col-6');
        $doc.find('.col-6.offset-md-8.replaceBeforeRender').removeClass('offset-md-8').addClass('offset-md-6');
        $doc.find('#glideChartReport').css({width: '90% !important'});
        $doc.find('br:not(.ignore)').replaceWith('<span style="white-space: pre">\n</span>');
        $doc.find('div.fake').replaceWith('AAA');
        return $doc[0];
    } 

    render() {  
        let fullSummaryInc = 8
        if(this.props.glidePath && this.props.glideOptimized){
            fullSummaryInc = 9
        }else if(this.props.glidePath || this.props.glideOptimized){
            fullSummaryInc = 8
        }else{
            fullSummaryInc = 7  
        }

        return (            
            <section className={"report-container " + (this.props.showingReport?'active':'')}>
                <div className="report-controls">
                    <button className="btn btn-sm btn-secondary" onClick={this.downloadReport}>Download</button>
                    <button type="button" className="btn btn-sm btn-secondary" data-dismiss="modal" aria-label="Close" onClick={() => {
                        Provider.hideReport();
                    }}>
                        Back
                    </button>
                    <div className="form-check">
                        <input className="form-check-input" type="checkbox" id="chkPageNums" checked={this.state.showingPageNumbers} onChange={() => {
                            this.setState({ showingPageNumbers: !this.state.showingPageNumbers });
                        }} />
                        <label className="form-check-label" htmlFor="chkPageNums">
                            Show Page Numbers
                        </label>
                    </div>
                </div>
                <div id="ReportOutput" className={"report " + (this.props.portrait ? 'report-portrait ' : 'report-landscape ') + (this.state.showingPageNumbers ? 'keep-page-numbers' : 'hide-page-numbers')}>
                    <TitlePage pageNumber={this.getPage()} addBreak={true} preparedFor={this.props.preparedFor} preparedBy={this.props.preparedBy} logo={this.props.logo} adviserLogo={this.props.adviserLogo} {...this.props} />                                                                                                                                                  
                    <TocPage pageNumber={this.getPage()} addBreak={true} preparedFor={this.props.preparedFor} reportIncludesMethodology={this.props.reportIncludesMethodology} {...this.props} />
                    <RiskProfilePage pageNumber={this.getPage()} addBreak={true} {...this.props}  />
                    <RankGraphPage pageNumber={this.getPage()} addBreak={true} {...this.props} />                    
                    <SummaryPage pageNumber={this.getPage()} addBreak={true} {...this.props} />
                    { this.props.summary ? <FullSummaryPage pageNumber={this.getPage(fullSummaryInc)} addBreak={true} {...this.props} /> : null }
                    { this.props.reportIncludesMethodology ? 
                        <MethodologyPages pageNumber={this.getPage(this.props.summary ? 0 : 9)} addBreak={true} {...this.props} />          
                    : null }
                    <DisclosuresPage pageNumber={this.getPage(this.props.reportIncludesMethodology ? (this.props.summary ? 8 : 8) : (this.props.summary ? 1 : 9))} addBreak={true} {...this.props} />  
                    
                 
                    <EndnotesPage pageNumber={this.getPage((!this.props.portrait && !this.props.quartiles) ? (this.props.summary ? (this.props.reportIncludesMethodology ? 3 : 3) : 3) : 2)} addBreak={false} {...this.props} />                                                                                                                                                          
                </div>                                                         
            </section>
        );
    }
}

export default Report;
